import type { NcIconProps } from "./nc-icon";
import { NcIcon } from "./nc-icon";

const NcIconThirdPartyHealthone = (props: NcIconProps) => (
  <NcIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.159 2C17.769 2 22 6.477 22 12s-4.23 10-9.841 10S2 17.523 2 12C2 6.505 6.7 2 12.159 2m2.6 2.717c-3.02-1.053-5.854-.21-8.074 1.973-1.457 1.509-1.987 3.543-1.973 5.586.116 4.564 3.734 7.556 8.188 7.282 1.69-.185 3.593-1.087 4.696-2.343 2.116-2.648 2.552-6.93-.216-9.242-3.881-2.739-9.31 1.038-7.61 5.69.682 1.51 1.013 2.636 3.865 3.148-1.867-.01-3.415-.06-4.963-1.21C4.152 12.3 7.164 5.15 12.47 5.05c2.176-.001 3.83.98 5.472 2.273-.57-1.246-1.957-2.1-3.184-2.605"
      clipRule="evenodd"
    />
  </NcIcon>
);
export { NcIconThirdPartyHealthone };
